export default __webpack_public_path__ + "static/media/skeleton-empty-img-md.e4049f99.svg";